
export interface ICenterRecipient {
    id: number,
    alias: string,
    centerId: number,
    centerAlias: string,
    chip: boolean
}